module.exports = __webpack_public_path__ + "static/media/icon2.06fa3dfd.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/question_bank/icon2.svg
// module id = 302
// module chunks = 0